<template>
  <ul class="mission-honeycomb" :class="{ 'is-completed': mission.hasCompleted }">
    <li
      v-for="(condition, index) in mission.achievementCondition"
      :key="index"
      class="mission-honeycomb__item"
    >
      <mission-hexagon-parts
        :condition="condition"
        :prevCondition="getPrevCondition(index)"
        :mission="mission"
        :checkInMissionsBeingHeld="checkInMissionsBeingHeld"
      />
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import MissionHexagonParts from '@/components/MissionPage/MissionListPane/parts/MissionHexagonParts.vue'
import { MissionProgressCardType } from '@/components/MissionPage/hook/useMissionProgressData'
import MissionProgressDocument from '@/store/stores/collectionModule/documents/mission/MissionProgressDocument'

/**
 * ミッション画面 ミッション達成状況 ハニカム10個パーツ
 */
export default defineComponent({
  name: 'MissionHoneycombSevenTenParts',
  components: {
    MissionHexagonParts,
  },
  props: {
    mission: {
      type: Object as PropType<MissionProgressCardType>,
      required: true,
    },
    /**
     * 開催中のラウンドチェックインまたはイベントチェックインミッション一覧
     */
    checkInMissionsBeingHeld: {
      type: Array as PropType<MissionProgressDocument[]>,
      required: true,
    },
  },
  setup(props) {
    /**
     * 一つ前の達成条件を取得する
     */
    const getPrevCondition = (index: number) =>
      index > 0 ? props.mission.achievementCondition?.[index - 1] : 'noPreviousCondition'

    return {
      getPrevCondition,
    }
  },
})
</script>

<style scoped lang="scss">
.mission-honeycomb {
  display: flex;
  gap: min(#{convertPXtoVW(5)}, 5px);
  flex-wrap: wrap;
  width: min(#{convertPXtoVW(279)}, 279px);
  margin-right: auto;
  margin-left: auto;

  &__item {
    &:nth-child(1),
    &:nth-child(8) {
      margin-left: min(#{convertPXtoVW(36)}, 36px);
    }

    &:nth-child(n + 4) {
      margin-top: max(#{convertPXtoVW(-18)}, -18px);
    }
  }

  &.is-completed {
    gap: min(#{convertPXtoVW(4)}, 4px);
    width: min(#{convertPXtoVW(216)}, 216px);

    .mission-honeycomb__item {
      &:nth-child(1),
      &:nth-child(8) {
        margin-left: min(#{convertPXtoVW(27)}, 27px);
      }

      &:nth-child(n + 4) {
        margin-top: max(#{convertPXtoVW(-13)}, -13px);
      }
    }
  }

  @media screen and (min-width: $responsiveTabletWidth) {
    gap: min(#{convertPXtoVW(8)}, 8px);
    width: min(#{convertPXtoVW(384)}, 384px);

    &__item {
      &:nth-child(1),
      &:nth-child(8) {
        margin-left: min(#{convertPXtoVW(49)}, 49px);
      }

      &:nth-child(n + 4) {
        margin-top: max(#{convertPXtoVW(-25)}, -25px);
      }
    }

    &.is-completed {
      gap: 6px;
      width: 298px;

      .mission-honeycomb__item {
        &:nth-child(1),
        &:nth-child(8) {
          margin-left: 38px;
        }

        &:nth-child(n + 4) {
          margin-top: -19px;
        }
      }
    }
  }
}
</style>
